import { createOptimizedPicture } from '../../../scripts/aem.js';
import { div, li, p, span, udex } from '../../../scripts/dom-builder.js';
import isExternal from '../../../scripts/utils/link-utils.js';
import { getHeaderTitle } from '../../../scripts/utils/text-utils.js';
import getArticleTagLabel from './get-article-tag.js';
import getAvatarElement from './get-avatar-element.js';
import getInfo from './get-info.js';
import getTagLabel from './get-tag-label.js';

export default function getFeatureArticleCard({
  articleData,
  author,
  tags,
  infoType,
  i18next,
  horizontal,
}) {
  const { path, title, cardTitle, description, image, cardC2A } = articleData;
  const tagLabel = getTagLabel(articleData, i18next);
  const contentType = getArticleTagLabel(articleData, tags);
  const isProxyCard = !!cardC2A;
  const info = cardC2A || getInfo({ articleData, author, infoType, i18next });
  const articleInfo = isProxyCard
    ? span({ class: 'card-external-link' }, '')
    : span('');

  (async () => {
    articleInfo.innerText = await info;
  })();

  return li(
    {
      class: `featured-articles-card ${horizontal ? 'horizontal' : ''} ${!image ? 'text-card' : ''}`,
    },
    udex(
      'tile',
      {
        interactive: true,
        href: path,
        target: isProxyCard && isExternal(path) ? '_blank' : '_self',
        dataActivityMapRegion: 'body|featured-articles',
      },
      getPictureElement(image),
      div(
        { class: 'cardcontent' },
        tagLabel ? span({ class: 'tag-label' }, tagLabel) : '',
        div({ class: 'type' }, contentType || ''),
        div({ class: 'title text' }, span(getHeaderTitle(cardTitle || title))),
        getDescription(horizontal, image, description),
      ),
      div(
        { class: 'infoblock' },
        getAvatarElement(author, infoType),
        div({ class: 'info' }, articleInfo),
      ),
    ),
  );
}

function getPictureElement(image) {
  return image ? div({ class: 'picture' }, getOptimizedPicture(image)) : span();
}

function getDescription(horizontal, image, description) {
  return (horizontal || !image) && description && description !== '0'
    ? p({ class: 'description' }, description)
    : span();
}

function getOptimizedPicture(image) {
  return createOptimizedPicture(image, '', [{ width: '750' }]);
}
